import { render, staticRenderFns } from "./IndagineEpidemiologicaEpatiteAViewComponent.vue?vue&type=template&id=febc6704"
import script from "./IndagineEpidemiologicaEpatiteAViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEpatiteAViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports